import { flex } from '../../../styled-system/patterns';
import { NotFound } from '#/components/Error';
import { useTitle } from '#/utils/useTitle';

export function NoMatch() {
  useTitle('ページが見つかりませんでした');
  return (
    <div
      className={flex({
        paddingTop: '{spacing.20}',
        paddingBottom: '{spacing.40}',
        width: '100%',
        sm: {
          paddingTop: '{spacing.40}',
          paddingBottom: '{spacing.56}',
        },
      })}
    >
      <NotFound />
    </div>
  );
}
